import React, { useEffect, useMemo, useState } from "react";
import "./SessoesUsuarios.css";

const API_BASE =
  window.location.hostname === "localhost"
    ? "https://welaunchyou.com.br/crm-wly"
    : "/crm-wly";

const ENDPOINT = `${API_BASE}/sessoes_usuario.php`;

function formatarTempoRelativo(segundos) {
  if (segundos === null || segundos === undefined) return "";

  const total = Number(segundos);

  if (Number.isNaN(total) || total < 0) return "";

  if (total < 60) {
    return `há ${total}s`;
  }

  const minutos = Math.floor(total / 60);

  if (minutos < 60) {
    return `há ${minutos} min`;
  }

  const horas = Math.floor(minutos / 60);
  const minutosRestantes = minutos % 60;

  if (minutosRestantes === 0) {
    return `há ${horas}h`;
  }

  return `há ${horas}h ${minutosRestantes}min`;
}

function formatarData(data) {
  if (!data) return "-";

  const partes = String(data).split(" ");
  if (partes.length !== 2) return data;

  const [dataParte, horaParte] = partes;
  const [ano, mes, dia] = dataParte.split("-");

  if (!ano || !mes || !dia) return data;

  return `${dia}/${mes}/${ano} ${horaParte}`;
}

function formatarMotivo(motivo) {
  if (!motivo) return "-";

  const mapa = {
    logout: "Logout",
    expirada: "Expirada",
    forcada: "Forçada",
  };

  return mapa[motivo] || motivo;
}

function formatarStatus(status) {
  if (!status) return "-";

  const mapa = {
    ativa: "Ativa",
    encerrada: "Encerrada",
  };

  return mapa[status] || status;
}

function resumirUserAgent(userAgent) {
  if (!userAgent) return "-";

  const ua = userAgent.toLowerCase();

  let navegador = "Navegador desconhecido";
  let sistema = "Sistema desconhecido";
  let dispositivo = "Desktop";

  if (ua.includes("edg/")) navegador = "Edge";
  else if (ua.includes("chrome/")) navegador = "Chrome";
  else if (ua.includes("safari/") && !ua.includes("chrome/")) navegador = "Safari";
  else if (ua.includes("firefox/")) navegador = "Firefox";

  if (ua.includes("windows")) sistema = "Windows";
  else if (ua.includes("mac os")) sistema = "macOS";
  else if (ua.includes("android")) sistema = "Android";
  else if (ua.includes("iphone") || ua.includes("ipad")) sistema = "iOS";
  else if (ua.includes("linux")) sistema = "Linux";

  if (ua.includes("mobile") || ua.includes("iphone") || ua.includes("android")) {
    dispositivo = "Mobile";
  }

  return `${navegador} • ${sistema} • ${dispositivo}`;
}

function montarLocalizacao(sessao) {
  const partes = [];

  if (sessao.geo_cidade) partes.push(sessao.geo_cidade);
  if (sessao.geo_estado) partes.push(sessao.geo_estado);
  if (sessao.geo_pais) partes.push(sessao.geo_pais);

  return partes.length > 0 ? partes.join(" / ") : "-";
}

export default function SessoesUsuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioId, setUsuarioId] = useState("");
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [sessoes, setSessoes] = useState([]);

  const [status, setStatus] = useState("");
  const [motivo, setMotivo] = useState("");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [limit, setLimit] = useState(100);

  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [loadingSessoes, setLoadingSessoes] = useState(false);
  const [erro, setErro] = useState("");
  const [totalSessoes, setTotalSessoes] = useState(0);

  const usuarioAtual = useMemo(() => {
    if (!usuarioId) return null;
    return usuarios.find((u) => String(u.id) === String(usuarioId)) || null;
  }, [usuarios, usuarioId]);

  async function buscarDados(idSelecionado = usuarioId, filtrosOverride = null) {
    setErro("");

    const params = new URLSearchParams();

const filtros = filtrosOverride || {
  status,
  motivo,
  dataInicio,
  dataFim,
  limit,
};

if (idSelecionado) params.append("usuario_id", idSelecionado);
if (filtros.status) params.append("status", filtros.status);
if (filtros.motivo) params.append("motivo", filtros.motivo);
if (filtros.dataInicio) params.append("data_inicio", filtros.dataInicio);
if (filtros.dataFim) params.append("data_fim", filtros.dataFim);
if (filtros.limit) params.append("limit", String(filtros.limit));

    const url = params.toString()
      ? `${ENDPOINT}?${params.toString()}`
      : ENDPOINT;

    try {
const temFiltroDeSessoes =
  idSelecionado ||
  filtros.status ||
  filtros.motivo ||
  filtros.dataInicio ||
  filtros.dataFim;

if (temFiltroDeSessoes) {
  setLoadingSessoes(true);
} else {
  setLoadingUsuarios(true);
}

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
      });

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.error || "Erro ao buscar sessões.");
      }

      setUsuarios(Array.isArray(data.usuarios) ? data.usuarios : []);
      setUsuarioSelecionado(data.usuario_selecionado || null);
      setSessoes(Array.isArray(data.sessoes) ? data.sessoes : []);
      setTotalSessoes(Number(data.total_sessoes || 0));
    } catch (error) {
      setErro(error.message || "Erro inesperado ao carregar dados.");
      setSessoes([]);
      setUsuarioSelecionado(null);
      setTotalSessoes(0);
    } finally {
      setLoadingUsuarios(false);
      setLoadingSessoes(false);
    }
  }

  useEffect(() => {
    buscarDados("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleSelecionarUsuario(e) {
    const novoUsuarioId = e.target.value;

    setUsuarioId(novoUsuarioId);
    setUsuarioSelecionado(null);
    setSessoes([]);
    setTotalSessoes(0);

    if (novoUsuarioId) {
      buscarDados(novoUsuarioId);
    }
  }

function handleAplicarFiltros(e) {
  e.preventDefault();

  setErro("");

  buscarDados(usuarioId || "", {
    status,
    motivo,
    dataInicio,
    dataFim,
    limit,
  });
}

function handleLimparFiltros() {
  setErro("");

  setUsuarioId("");
  setUsuarioSelecionado(null);
  setSessoes([]);
  setTotalSessoes(0);

  setStatus("");
  setMotivo("");
  setDataInicio("");
  setDataFim("");
  setLimit(100);
}

  return (
    <div className="sessoes-page">
      <div className="sessoes-header">
        <div>
          <h1>Histórico de Sessões</h1>
          <p>
            Consulte os acessos dos usuários, incluindo IP, localização aproximada,
            dispositivo, início, último ping e encerramento.
          </p>
        </div>
      </div>

      {erro && (
        <div className="sessoes-alert sessoes-alert-error">
          {erro}
        </div>
      )}

      <div className="sessoes-card sessoes-filtros-card">
        <form className="sessoes-filtros" onSubmit={handleAplicarFiltros}>
          <div className="sessoes-field sessoes-field-user">
            <label>Usuário</label>
            <select value={usuarioId} onChange={handleSelecionarUsuario}>
              <option value="">
                {loadingUsuarios ? "Carregando usuários..." : "Selecione um usuário"}
              </option>

              {usuarios.map((usuario) => (
                <option key={usuario.id} value={usuario.id}>
                  {usuario.nome} — {usuario.email}
                </option>
              ))}
            </select>
          </div>

          <div className="sessoes-field">
            <label>Status</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="">Todos</option>
              <option value="ativa">Ativa</option>
              <option value="encerrada">Encerrada</option>
            </select>
          </div>

          <div className="sessoes-field">
            <label>Motivo</label>
            <select value={motivo} onChange={(e) => setMotivo(e.target.value)}>
              <option value="">Todos</option>
              <option value="logout">Logout</option>
              <option value="expirada">Expirada</option>
              <option value="forcada">Forçada</option>
            </select>
          </div>

          <div className="sessoes-field">
            <label>Data inicial</label>
            <input
              type="date"
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
            />
          </div>

          <div className="sessoes-field">
            <label>Data final</label>
            <input
              type="date"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
            />
          </div>

          <div className="sessoes-field">
            <label>Limite</label>
            <select
              value={limit}
              onChange={(e) => setLimit(Number(e.target.value))}
            >
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
            </select>
          </div>

          <div className="sessoes-actions">
            <button
              type="submit"
              className="sessoes-btn sessoes-btn-primary"
              disabled={loadingSessoes}
            >
              {loadingSessoes ? "Buscando..." : "Aplicar filtros"}
            </button>

            <button
              type="button"
              className="sessoes-btn sessoes-btn-secondary"
              onClick={handleLimparFiltros}
              disabled={loadingSessoes}
            >
              Limpar
            </button>
          </div>
        </form>
      </div>

      {usuarioAtual && (
        <div className="sessoes-card sessoes-user-card">
          <div>
            <span className="sessoes-label">Usuário selecionado</span>
            <h2>{usuarioAtual.nome}</h2>
            <p>{usuarioAtual.email}</p>
          </div>

          <div className="sessoes-user-meta">
            <span className={`sessoes-chip sessoes-chip-${usuarioAtual.status}`}>
              {usuarioAtual.status}
            </span>
            <span className="sessoes-chip">
              {usuarioAtual.tipo_usuario}
            </span>
          </div>
        </div>
      )}

      <div className="sessoes-stats">
        <div className="sessoes-stat-card">
          <span>Total encontrado</span>
          <strong>{totalSessoes}</strong>
        </div>

        <div className="sessoes-stat-card">
          <span>Exibindo</span>
          <strong>{sessoes.length}</strong>
        </div>

        <div className="sessoes-stat-card">
          <span>Sessões ativas</span>
          <strong>{sessoes.filter((s) => s.status === "ativa").length}</strong>
        </div>

        <div className="sessoes-stat-card">
          <span>Sessões encerradas</span>
          <strong>{sessoes.filter((s) => s.status === "encerrada").length}</strong>
        </div>
      </div>

      <div className="sessoes-card sessoes-table-card">
        <div className="sessoes-table-header">
          <div>
            <h2>Sessões</h2>
            <p>
                {usuarioSelecionado
                ? `Histórico de ${usuarioSelecionado.nome}`
                : "Histórico de todos os usuários"}
            </p>
          </div>
        </div>

        {loadingSessoes ? (
          <div className="sessoes-empty">
            Carregando sessões...
          </div>
            ) : sessoes.length === 0 ? (
          <div className="sessoes-empty">
            Nenhuma sessão encontrada para os filtros selecionados.
          </div>
        ) : (
          <div className="sessoes-table-wrap">
            <table className="sessoes-table">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Usuário</th>
                  <th>Início</th>
                  <th>Último ping</th>
                  <th>Fim</th>
                  <th>Duração</th>
                  <th>Motivo</th>
                  <th>IP</th>
                  <th>Localização</th>
                  <th>Provedor</th>
                  <th>Dispositivo</th>
                  <th>Session ID</th>
                </tr>
              </thead>

              <tbody>
                {sessoes.map((sessao) => (
                  <tr key={sessao.id}>
                    <td>
                      <span className={`sessoes-status sessoes-status-${sessao.status}`}>
                        {formatarStatus(sessao.status)}
                      </span>
                    </td>

                    <td>
                        <strong>{sessao.usuario_nome || "-"}</strong>
                        <small>{sessao.email || "-"}</small>
                    </td>

                    <td>{formatarData(sessao.data_inicio)}</td>

                    <td>
                      <div>{formatarData(sessao.ultimo_ping)}</div>

                      {sessao.status === "ativa" &&
                        sessao.segundos_desde_ultimo_ping !== null && (
                          <small>
                            {formatarTempoRelativo(sessao.segundos_desde_ultimo_ping)}
                          </small>
                        )}
                    </td>

                    <td>{formatarData(sessao.data_fim)}</td>

                    <td>{sessao.duracao_formatada || "-"}</td>

                    <td>{formatarMotivo(sessao.motivo_encerramento)}</td>

                    <td>
                      <code>{sessao.ip || "-"}</code>
                    </td>

                    <td>{montarLocalizacao(sessao)}</td>

                    <td>
                      <div>{sessao.geo_isp || "-"}</div>
                      {sessao.geo_org && <small>{sessao.geo_org}</small>}
                    </td>

                    <td>
                      <div>{resumirUserAgent(sessao.user_agent)}</div>
                      {sessao.user_agent && (
                        <details className="sessoes-user-agent-details">
                          <summary>Ver completo</summary>
                          <span>{sessao.user_agent}</span>
                        </details>
                      )}
                    </td>

                    <td>
                      <code className="sessoes-session-id">
                        {sessao.session_id || "-"}
                      </code>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  ); 
}